import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { LoaderComponent } from './loader/loader.component';
import { MaterialModule } from './material/material.module';
import { ClickOutsideModule } from 'ng-click-outside';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [HeaderComponent, SideMenuComponent, LoaderComponent],
  exports: [SideMenuComponent, HeaderComponent, MaterialModule, LoaderComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
    MaterialModule,
    RouterModule,
    FlexLayoutModule,
    ClickOutsideModule
  ]
})
export class LayoutModule { }
